export default "__VITE_ASSET__390dbf41__"